<template>
  <div class="flex-1 relative text-start w-full h-full overflow-hidden dark:bg-dark-screen-background">
    <div class="w-full h-full mt-10 overflow-scroll no-scrollbar">
      <MapPreview :linked-record="linkedRecord" :connect-to="connectTo" :label="label" :is-map-edit-on="is_map_edit_on" />
    </div>
  </div>
</template>
<script>
import MapPreview from "./maps-components/MapPreview.vue"

export default {
  name: "CompanyMapTab",
  components: {
    MapPreview
  },
  props: {
    linkedRecord: null,
    connectTo: null,
    label: null
  },

  data() {
    return {
      is_map_edit_on: false
    }
  }
}
</script>
